const data = [
  {
    title: 'Мы используем в  нашей работе только качественную продукцию, безопасную для вас и ваших детей',
    // text: `При заказе от 1500р. Вы получите «подарок» — любую надпись на стандартном шаре! Для постоянных клиентов, подписанных на наш инстаграм действует накопительная скидка от 3-7%.`
  },

  {
    title: 'У нас всегда в наличии самый широкий выбор шаров в городе, на любой праздник.',
    // text: `Мы ценим свою репутацию , поэтому в своей работе используем только самые качественные шары, клей и гелий.`
  },

  {
    title: 'Оформим шарами и не только, любой ваш праздник.',
    // text: `Мы доставим Ваш заказ точно в срок, в чистой герметичной упаковке!`
  },

  {
    title: 'Доставим Ваш заказ, в чистой герметичной упаковке, точно в срок. Возможна бесплатная доставка без привязки по времени.',
    // text: `Предложим Вам самые оптимальные решения под ваше желание и возможности. Мы реализуем любую Вашу идею или сами предложим решения под ваш бюджет.`
  },

  {
    title: 'Срочный заказ за 1 час, в рабочее время студии!',
    // text: `Безналичный расчет, шары с вашим логотипом, оформление коммерческих объектов и корпоративных праздников. Звоните - мы всегда договоримся.`
  },

  {
    title: 'Сделаем любую вашу надпись на шар за 10 мин!',
    // text: `У нас в наличии всегда более 1800 видов шаров и сопутствующих материалов. А если Вы чего то у нас не найдете, то мы привезем это в кратчайшие сроки!`
  },
]

export default data;